document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const slides = gallery.querySelectorAll('[data-gallery-slide]');
  const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

  const switchToMedia = (mediaId) => {
    if (!mediaId) return;
    const id = String(mediaId);
    let matched = false;
    slides.forEach((slide) => {
      const isMatch = slide.dataset.gallerySlide === id;
      slide.classList.toggle('is-active', isMatch);
      if (isMatch) matched = true;
    });
    thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.galleryThumb === id));
    return matched;
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => switchToMedia(thumb.dataset.galleryThumb));
  });

  gallery.switchToMedia = switchToMedia;
});
